<template>
    <div class="app-calendar-empty-menu">
        <img src="/icons/empty-menu.svg" alt="Select a school and a meal period to see a menu" class="app-calendar-empty-menu-img" />
        <div class="app-calendar-empty-menu-text">Select a school and a meal period to see a menu</div>
    </div>
</template>

<script>
export default {
    name: 'EmptyMenu'
}
</script>